// extracted by mini-css-extract-plugin
export default {"root":"modules__common__creation-menu-fields__discount-editor__root"};